export default "__VITE_ASSET__pdTxXU2Y__"